export default function createFormData(obj: object) {
    return Object.entries(obj).map(i => `${ i[0] }=${ encodeURIComponent(i[1]) }`).join('&');
}
